import React from "react";
import {Switch, Route, Link} from 'react-router-dom'
import ReactModal from 'react-modal';
import {withRouter} from 'react-router-dom'

import LayoutService from '../Services/LayoutService'

import Group from './Group';

import StudioDisplay from "./DetailPages/StudioDisplay";
import SportAngebotDisplay from "./SportAngebotDisplay";
import SportCenterDisplay from "./SportCenterDisplay";
import MitgliedWerdenDisplay from "./DetailPages/MitgliedWerdenDisplay";
import KontaktDisplay from "./DetailPages/KontaktDisplay";
import UeberDisplay from "./DetailPages/UeberDisplay";
import SportprogrammDisplay from "./SportprogrammDisplay";
import KursanmeldungDisplay from "./KursanmeldungDisplay";
import SportArtDisplay from "./SportArtDisplay";
import SearchDisplay from "./SearchDisplay";
import ImpressumDisplay from "./DetailPages/ImpressumDisplay"
import HomeDisplay from "./HomeDisplay";
import Abteilung from "./Abteilung";
import JobsDisplay from "./DetailPages/JobsDisplay";
import VeranstaltungsDisplay from "./DetailPages/VeranstaltungsDisplay";
import VeranstaltungsSingleDisplay from "./DetailPages/VeranstaltungsSingleDisplay";

import JobsSingleDetail from "./DetailPages/JobSingleDisplay";

import SModalDisplay from "../StyleComponents/SModalDisplay"
import TgbDataSource from "../DataSources/TgbDataSource";

import PageDataService from "../DataSources/PageDataService";
import PageDisplayById from "./PageDisplayById";
import SettingsService from "../DataSources/SettingsService";
import VirtualGymDisplay from "./DetailPages/VirtualGymDisplay";
import ReservationDisplay from "./DetailPages/ReservationDisplay"
import ReservationBookingAdminOverviewDisplay from "./DetailPages/ReservationBookingAdminOverviewDisplay";
import AnmeldeForm from "./shared/AnmeldeForm";
import appSpecific from "../AppSpecificWebPreview";
import EnterNumberDisplay from "./EnterNumberDisplay";
import UeberUnsDisplay from "./UeberUnsDisplay";

class Main extends React.Component {
    constructor() {
        super();

        this.isInternDisplay = false;
        this.vGymLinkArray = [];
        this.vGymOb = {
            title: 'Virtuelles Gym',
            children: this.vGymLinkArray,
            path: '/virtualgym',
            importance: 1
        };
        this.abteilungsSeitenLinkArray = [];
        this.ueberUnsSeitenLinkArray = [];
        this.abteilungsSeitenOb = {
            title: 'Abteilungsseiten',
            children: this.abteilungsSeitenLinkArray,
            importance: 2
        };
        this.ueberUnsSeitenOb = {
            title: 'Über Uns',
            children: this.ueberUnsSeitenLinkArray,
            importance: 2
        };
        this.state = {
            isSearchActive: false,
            drawerSlideState: 'hidden',
            error: "",
            isLoaded: false,

            linkArray: [
                {title: 'Start', path: '/', importance: 0},
                {title: 'Sportprogramm', path: '/sportprogramm', importance: 1},
                //{title: 'Kursanmeldung', path: '/kursanmeldung', importance: 3},
                {title: 'Kursanmeldung', link: SettingsService.getMainPageUrl() + 'v3/app/#/kurse', importance: 3},
                this.vGymOb,
                {title: 'Mitglied werden', path: '/mitgliedwerden', importance: 3},
                this.abteilungsSeitenOb,
                this.ueberUnsSeitenOb
            ],

        };
        /*
        {
                    title: 'Über uns', path: '/ueber', children: [
                        {title: 'Über die TGB', path: '/ueber'},
                        {title: 'Leitbild', path: '/leitbild'},
                        {title: 'Veranstaltungen', path: '/veranstaltungen'},
                        {title: 'Impressum', path: '/impressum'},

                        {title: 'Team', path: '/team'},
                        {title: 'Ehrenamt', path: '/ehrenamt'},
                        {title: 'Corona Hinweise', path: '/corona'},
                        {title: 'Jobs', path: '/jobs'},
                        {title: 'Presse', path: '/presse'},
                        {title: 'Kontakt', path: '/kontakt'},
                        {title: 'Datenschutz', link: SettingsService.getMainPageUrl() + 'datenschutz/datenschutz.pdf'}
                    ]
                }
         */


        this.updateLinks();
        this.updateDimensions();

        window.addEventListener("resize", () => {
            console.log("update dimensions");
            this.updateDimensions();
            LayoutService.triggerLayoutChange();

            //LayoutService.triggerLayoutChange();
            this.setState(this.state);

        });


        window.showIframe = (src) => {
            if (!this.isMobileDisplay()) {
                this.state.showIframeUrl = src;
                this.state.showIframe = true;
                this.setState(this.state);
            } else {
                if (src.indexOf("pdf") !== -1) {
                    //window.open(src, '_blank');


                    /*if (navigator.userAgent.match(/Android/i)) {
                        src = 'https://docs.google.com/viewer?url=' + src.replace(/&/g, '%26') + '&embedded=true';
                    }*/
                    this.state.showPdfFrame = true;
                    this.state.showIframeUrl = src;
                    this.setState(this.state);

                    /*
                    alert('doing it here');
                    var link = document.createElement("a");
                    link.download = "download.pdf";
                    link.href = src;
                    link.click();
                    */
                } else {
                    window.open(src, '_blank');
                }
            }
        };

        setInterval(() => {
            if (TgbDataSource.timeSinceLastLoadInMs() > 30 * 60 * 1000) {
                console.log("reloading because of time");
                TgbDataSource.load();
            } else {
                console.log("not yet reloading", TgbDataSource.timeSinceLastLoadInMs());
            }
            TgbDataSource.load();
        }, 60000);
    }

    addMenuRecursive(array, menu,addStart) {

        let entry = {title: menu._title, path: menu._path};

        if (menu._title === 'Fitness Studio') {
            entry.path = '/group/studio';
        }
        array.push(entry);
        let children = [];
        Object.keys(menu).forEach((childKey) => {
            if (childKey.indexOf('_') !== 0) {
                children.push(menu[childKey]);
            }
        });
        children.sort((a, b) => {
            return a._order - b._order;
        });
        children.forEach((child) => {
            if (!entry.children) {
                entry.children = [];
                if(addStart){
                    entry.children.push({title: 'Start', path: menu._path, order: -1});
                }
            }
            this.addMenuRecursive(entry.children, child);
//                console.log('child',childKey,menu[childKey]);
        });


        //  console.log('this.abteilungsSeitenLinkArray',this.abteilungsSeitenLinkArray);

    }

    updateLinks() {
        this.vGymLinkArray.length = 0;
        //this.abteilungsSeitenLinkArray = [{title: 'Fitness Studio', path: '/group/studio'}];

        const addHierarchical=(targetArray,sourceOb,addStart)=>{

            targetArray.length=0;

            const keys = Object.keys(sourceOb);

            let children = [];
            keys.forEach((key) => {
                const abt = sourceOb[key];
                let menu = abt['_menu'];
                if (menu) {
                    children.push(menu);
                }
            });
            children.sort((a, b) => {
                return a._order - b._order;
            })
            children.forEach((child) => {
                this.addMenuRecursive(targetArray, child,addStart);
            });
            if (targetArray.length > 0) {
                targetArray.path = targetArray[0].path;
            }
        }
        addHierarchical(this.abteilungsSeitenLinkArray,PageDataService.abteilungsSeiten,true);
        addHierarchical(this.ueberUnsSeitenLinkArray,PageDataService.ueberUnsSeiten,false);
        this.ueberUnsSeitenLinkArray.push({title: 'Datenschutz', link: SettingsService.getMainPageUrl() + 'datenschutz/datenschutz.pdf'});
        for(let i=this.ueberUnsSeitenLinkArray.length-1;i>=0;i--){
            let l = this.ueberUnsSeitenLinkArray[i];
            if(l.title==="Abteilungsseiten"){
                this.ueberUnsSeitenLinkArray.splice(i,1);
            }

        }

        {
            const keys = Object.keys(PageDataService.vgymSeiten);

            let children = [];
            keys.forEach((key) => {
                const abt = PageDataService.vgymSeiten[key];
                let menu = abt['_menu'];
                if (menu) {
                    children.push(menu);
                }
            });
            children.sort((a, b) => {
                return a._order - b._order;
            })
            children.forEach((child) => {
                this.addMenuRecursive(this.vGymLinkArray, child,true);
            });
            if (this.vGymLinkArray.length > 0) {
                this.vGymOb.path = this.vGymLinkArray[0].path;
            }

        }



        //PageDataService.abteilungsSeiten
        this.updateSmallLinkArray();
        //console.log("this.state", this.state);
    }

    updateSmallLinkArray() {
        this.state.linkArraySmall = [];
        for (var smallerLinks = 0; smallerLinks <= 3; smallerLinks++) {
            let linkArraySmall = [];
            let notImportantLinks = [];
            this.state.linkArray.forEach(function (link) {
                if (link.importance && link.importance > smallerLinks) {
                    linkArraySmall.push(link);
                } else {
                    notImportantLinks.push(link)
                }
            });
            linkArraySmall.push({
                title: 'Mehr...', path: '/', children: notImportantLinks
            });
            this.state.linkArraySmall[smallerLinks] = linkArraySmall;
        }
    }

    componentWillMount() {
        console.log("COmponent will mount");
        PageDataService.onChange(() => {
            this.updateLinks();
            this.setState(this.state);
        });

        this.baseUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
        this.appHistory = [];
        if (window.location.hash !== '') {
            this.appHistory.push('/' + window.location.hash);
        }
        console.log("location", this.baseUrl, window.location);
        this.props.history.listen((location, action) => {

            // scroll to top
            document.body.scrollTop = document.documentElement.scrollTop = 0;

            if (this.appHistory.indexOf(location.pathname) !== -1) {
                console.log("already found " + location.pathname + " " + this.appHistory.indexOf(location.pathname));
                this.appHistory = this.appHistory.slice(this.appHistory.indexOf(location.pathname) - 1);
            } else {
                if (location.pathname === '/') {
                    this.appHistory = [];
                } else {
                    this.appHistory.push(location.pathname);
                }
            }
            // location is an object like window.location
            console.log("history", this.appHistory, action, location.pathname, location.state)
        });
        TgbDataSource.onError((error) => {
            if (!this.state.error) {
                this.state.error = '';
            }
            this.state.error += "\n " + error;
            this.setState(this.state);
        })
        TgbDataSource.onChange(() => {
            this.state.isLoaded = true;
            //throw "test";
            this.setState(this.state);
        })
    }

    onSearchEnter(value) {
        console.log("onsearch", value, this);

        this.props.history.push("/search/" + value);
    }


    onSearchClick() {
        this.state.isSearchActive = true;
        this.setState(this.state);
        this.searchInput.focus();
    }

    onSearchBlur() {
        console.log("search blur");
        this.state.isSearchActive = false;
        this.setState(this.state);
    }


    updateDimensions() {
        let width = window.innerWidth;
        var sizeClass = "";

        LayoutService.minWidth = 60;
        var borderWidth = 100;

        var isMobileSmall = false;
        var isTiny = false;
        if (width < 1100) {
            sizeClass = "smalldisplay";
        }
        if (width < 800) {
            isTiny = true;
            sizeClass = "tinydisplay";
        }
        if (width < 430) {
            isMobileSmall = true;
            sizeClass = "mobilesmalldisplay";
            borderWidth = 60;
        }

        if (width < LayoutService.minWidth) {
            width = LayoutService.minWidth;
            borderWidth = 10;
        }

        if (width > 1200) {
            width = 1200;
        }
        /*if (width > 1200) {
            width -= width * 0.1;
        }*/


        let fullContentWidth = width - borderWidth;
        let rightWidth = 260;

        LayoutService.topFixedWidth = window.innerWidth;

        LayoutService.isTiny = isTiny;
        LayoutService.topMenuHeight = 66;
        LayoutService.topHeight = 66;
        LayoutService.topMarginHeight = 70;//+ 20;
        /*if (isMobileSmall) {
            LayoutService.topHeight = 80;
            LayoutService.topMenuHeight = 40;
            LayoutService.topMarginHeight = 80;
        }*/


        LayoutService.topFixedWidthForContent = fullContentWidth + 80;
        if (LayoutService.topFixedWidthForContent > LayoutService.topFixedWidth) {
            LayoutService.topFixedWidthForContent = LayoutService.topFixedWidth;
        }
        LayoutService.topFixedWidthForContent -= 30;

        /*if(width>800){
            var w = width-800;
            w/=500;
            rightWidth +=100*w;
        }*/
        let leftWidth = fullContentWidth - rightWidth;

        let rightContentWidth = rightWidth - 40;

        if (fullContentWidth < 550) {
            rightWidth = 0;
            rightContentWidth = 0;
            leftWidth = fullContentWidth;
        }

        LayoutService.fullWidth = width;

        var iFrameFac = 0.9;
        if (this.isMobileDisplay()) {
            iFrameFac = 0.90;
            width = window.innerWidth;
        }
        this.state.calcStyle = {
            width: width,
            iframeWidth: width * iFrameFac,
            iframeHeight: window.innerHeight * 0.8,
            fullContentHeight: window.innerHeight - 100,
            fullHeight: window.innerHeight - 130 - 130,
            sizeClass: sizeClass
        };


        console.log("calcStyle", this.state.calcStyle);
        LayoutService.fullContentWidth = fullContentWidth;
        LayoutService.leftWidth = leftWidth;
        LayoutService.fullHeight = this.state.calcStyle.fullHeight;
        LayoutService.fullContentHeight = this.state.calcStyle.fullContentHeight;

        LayoutService.rightWidth = rightWidth;
        LayoutService.rightContentWidth = rightContentWidth;
        LayoutService.iframeWidth = this.state.calcStyle.iframeWidth;
        LayoutService.iframeHeight = this.state.calcStyle.iframeHeight;

//        LayoutService.copyLayoutDataToState(this.state);


        this.state.calcStyle.fullContentWidth = fullContentWidth;
        this.state.calcStyle.leftWidth = leftWidth;
        this.state.calcStyle.rightWidth = rightWidth;
        this.state.calcStyle.rightContentWidth = rightContentWidth;


    }

    isMobileDisplay() {
        return LayoutService.fullWidth < 660;
    }

    render() {

        let currentLinkArray = this.state.linkArray;
        if (LayoutService.fullWidth < 1050) {
            currentLinkArray = this.state.linkArraySmall[0];
        }
        if (LayoutService.fullWidth < 900) {
            currentLinkArray = this.state.linkArraySmall[1];
        }
        if (LayoutService.fullWidth < 800) {
            currentLinkArray = this.state.linkArraySmall[2];
        }
        var drawerOpened = false;
        var mobileDisplay = false;
        if (this.isMobileDisplay()) {
            mobileDisplay = true;
            drawerOpened = this.state.drawerOpened;
        }
        console.log("this.appHistory.length", this.appHistory.length);
        return (
            <div className={this.state.calcStyle.sizeClass + " " + this.props.className}>
                <EnterNumberDisplay/>
                <div className={this.state.drawerSlideStateBg} style={{
                    width: "100%",
                    minWidth: LayoutService.minWidth,
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: 'rgb(247, 247, 250)',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <div className={"contentSplitterTop"} style={{marginTop: LayoutService.topMarginHeight}}/>

                    {
                        (this.state.isLoaded && !this.state.error) &&
                        <Switch>

                            <Route path='/impressum' component={ImpressumDisplay}/>
                            <Route path='/anmeldeTest' component={AnmeldeForm}/>
                            <Route path='/search/:search' component={SearchDisplay}/>
                            <Route path='/group/studio' component={StudioDisplay}/>
                            <Route path='/sportcenter/26' component={StudioDisplay}/>
                            <Route path='/sportcenter/22' component={StudioDisplay}/>
                            <Route path='/sportart/130' component={StudioDisplay}/>
                            <Route path='/sportart/108' component={StudioDisplay}/>
                            <Route path='/abteilung/:abteilungsId/:subPage' component={Abteilung}/>
                            <Route path='/ueberUns/:abteilungsId/:subPage' component={UeberUnsDisplay}/>
                            <Route path='/jobs/:jobId' component={JobsSingleDetail}/>
                            <Route path='/team/'
                                   render={(props) => <PageDisplayById id={699} title={"Team"} {...props} />}/>
                            <Route path='/ehrenamt/'
                                   render={(props) => <PageDisplayById id={4289} title={"Ehrenamt"} {...props} />}/>
                            <Route path='/corona/' render={(props) => <PageDisplayById id={4447}
                                                                                       title={"Corona Hinweise"} {...props} />}/>
                            <Route path='/virtualgym/:abteilungsId/:subPage' component={VirtualGymDisplay}/>

                            <Route path='/virtualgym/' render={(props) => <VirtualGymDisplay {...props} />}/>
                            <Route path='/veranstaltungen/:veranstaltungsId' component={VeranstaltungsSingleDisplay}/>
                            <Route path='/group/:groupId' component={Group}/>
                            <Route path='/sportart/:id' component={SportArtDisplay}/>
                            <Route path='/mitgliedwerden/' component={MitgliedWerdenDisplay}/>
                            <Route path='/sportprogramm/' component={SportprogrammDisplay}/>
                            <Route path='/kursanmeldung/' component={KursanmeldungDisplay}/>
                            <Route path='/kontakt/' component={KontaktDisplay}/>
                            <Route path='/ueber/' component={UeberDisplay}/>
                            <Route path='/leitbild/'
                                   render={(props) => <PageDisplayById id={5903} title={"Leitbild"} {...props} />}/>
                            <Route path='/presse/'
                                   render={(props) => <PageDisplayById id={2344} title={"Presse"} {...props} />}/>
                            <Route path='/reservierung/' component={ReservationDisplay}/>
                            <Route path='/reservierung-admin/'>
                                <ReservationDisplay displayOnly={true}/>
                            </Route>
                            <Route path='/reservierung-admin-list/'>
                                <ReservationBookingAdminOverviewDisplay/>
                            </Route>
                            <Route path='/jobs/' component={JobsDisplay}/>
                            <Route path='/veranstaltungen/' component={VeranstaltungsDisplay}/>
                            <Route path='/sportcenter/:id' component={SportCenterDisplay}/>
                            <Route path='/angebot/:id' component={SportAngebotDisplay}/>
                            <Route path='/' component={HomeDisplay}/>
                        </Switch>
                    }
                    {
                        (!this.state.isLoaded && !this.state.error) &&
                        <div className="loadingText">
                            Daten werden geladen...
                        </div>
                    }
                    {
                        (this.state.error) &&
                        <div className="loadingText">
                            {this.state.error}
                        </div>
                    }
                    <div className="bottomLine">
                        <Link className="clickable" to="/impressum">Impressum</Link>

                        <span> </span>| <a onClick={() => {
                        window.showIframe(SettingsService.getMainPageUrl() + 'datenschutz/datenschutz.pdf')
                    }}>Datenschutz</a>
                        <br/>

                        <div className="copyright">Copyright (c) Turngemeinde Bornheim 1860 e.V.</div>

                        <div className="copyright">{SettingsService.getVersionText()}</div>
                        {
                            appSpecific.usePreviewData &&
                            <div className="copyright">Preview Daten werden angezeigt</div>
                        }


                    </div>

                    <SModalDisplay/>


                    <ReactModal
                        isOpen={this.state.showIframe}
                        contentLabel="Close"
                        onRequestClose={() => {
                            this.state.showIframe = false;
                            this.state.showPdfFrame = false;
                            this.setState(this.state);
                        }}
                        className="Modal"
                        overlayClassName="Overlay"
                    >
                        <iframe src={this.state.showIframeUrl} style={{
                            width: this.state.calcStyle.iframeWidth,
                            height: this.state.calcStyle.iframeHeight
                        }} allowFullScreen>

                        </iframe>
                    </ReactModal>
                    <ReactModal
                        isOpen={this.state.showPdfFrame}
                        contentLabel="Close"
                        onRequestClose={() => {
                            this.state.showIframe = false;
                            this.state.showPdfFrame = false;
                            this.setState(this.state);
                        }}
                        className="Modal"
                        overlayClassName="Overlay"
                    >
                        <iframe src={this.state.showIframeUrl} style={{
                            width: this.state.calcStyle.iframeWidth,
                            height: this.state.calcStyle.iframeHeight
                        }} allowFullScreen></iframe>
                        <div style={{marginTop: 10}}>
                            <center>
                                <a className="downloadLink" target="_blank" href={this.state.showIframeUrl}>Pdf Datei
                                    downloaden</a>
                                <a className="downloadLink" onClick={() => {
                                    this.state.showIframe = false;
                                    this.state.showPdfFrame = false;
                                    this.setState(this.state);

                                }}>Schließen</a>
                            </center>
                        </div>

                    </ReactModal>

                </div>
                <div className={"mainBlueTop " + this.state.drawerSlideStateBg} style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    height: LayoutService.topHeight,
                    width: LayoutService.topFixedWidth,
                    minWidth: LayoutService.topFixedWidth,
                    backgroundImage: "url(res/top_bg_gradient.png)",
                    backgroundSize: 'contain',
                }}>
                    <div style={{
                        width: LayoutService.topFixedWidthForContent,
                        marginLeft: (LayoutService.topFixedWidth - LayoutService.topFixedWidthForContent) * 0.5,
                        height: LayoutService.topHeight,
                        marginBottom: 0,
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                    }}>
                        {
                            mobileDisplay && this.appHistory.length > 0 && !this.state.isSearchActive &&
                            <i className="fas fa-chevron-left backSymbol" onClick={() => {
                                console.log("this.appHistory", this.appHistory);
                                if (this.appHistory.length == 1) {
                                    this.props.history.push('/');
                                } else {
                                    this.props.history.push(this.appHistory[this.appHistory.length - 2]);
                                }
                            }}></i>
                        }
                        {
                            mobileDisplay &&
                            <i className="fas fa-bars drawerSymbol" onClick={() => {
                                this.state.drawerOpened = true;
                                this.state.drawerSlideState = 'slideIn';
                                this.state.drawerSlideStateBg = 'slideInBg';
                                this.setState(this.state);
                            }}></i>
                        }


                        <Link to=""><img
                            className={"tgbTopImage" + (this.state.isSearchActive ? " searchActive" : "")}
                            src="res/logo_full_white.png"/></Link>
                        <div className="topmenu mainMenu"
                             style={{
                                 display: this.state.isSearchActive ? 'none' : 'flex',
                             }}
                        >
                            <nav>
                                <ul className="firstMenu">
                                    {
                                        !mobileDisplay &&
                                        currentLinkArray.map((ob) =>
                                            <li key={ob.title}>
                                                {
                                                    ob.link &&
                                                    <a href={ob.link}>{ob.title}</a>
                                                }
                                                {
                                                    (ob.path) &&
                                                    <Link to={ob.path}>{ob.title}</Link>
                                                }
                                                {
                                                    (!ob.path) && (!ob.link) &&
                                                    <a>{ob.title}</a>
                                                }
                                                {
                                                    ob.children &&
                                                    <ul>
                                                        {
                                                            ob.children.map((ob) =>
                                                                <li key={ob.title}>
                                                                    {
                                                                        ob.link &&
                                                                        <a href={ob.link}>{ob.title}</a>
                                                                    }
                                                                    {
                                                                        (ob.path) &&
                                                                        <Link to={ob.path}>{ob.title}</Link>
                                                                    }
                                                                    {
                                                                        ob.children &&
                                                                        <ul>
                                                                            {
                                                                                ob.children.map((ob) =>
                                                                                    <li key={ob.title}>
                                                                                        {
                                                                                            ob.link &&
                                                                                            <a href={ob.link}>{ob.title}</a>
                                                                                        }
                                                                                        {
                                                                                            (ob.path) &&
                                                                                            <Link
                                                                                                to={ob.path}>{ob.title}</Link>
                                                                                        }
                                                                                        {
                                                                                            ob.children &&
                                                                                            <ul>
                                                                                                {
                                                                                                    ob.children.map((ob) =>

                                                                                                        <li key={ob.title}>
                                                                                                            {
                                                                                                                ob.link &&
                                                                                                                <a href={ob.link}>{ob.title}</a>
                                                                                                            }
                                                                                                            {
                                                                                                                (ob.path) &&
                                                                                                                <Link
                                                                                                                    to={ob.path}>{ob.title}</Link>
                                                                                                            }
                                                                                                        </li>
                                                                                                    )
                                                                                                }
                                                                                            </ul>
                                                                                        }
                                                                                    </li>
                                                                                )
                                                                            }
                                                                        </ul>
                                                                    }
                                                                </li>
                                                            )
                                                        }
                                                    </ul>
                                                }
                                            </li>
                                        )
                                    }
                                </ul>
                            </nav>
                        </div>
                        <div className="centerIcon wrapper searchIcon-right" style={{
                            borderRadius: 10,
                            backgroundColor: 'rgb(50, 116, 168)',
                            alignItems: 'center',
                            justifyContent: 'center',
                            shadowColor: "#000",
                            shadowOffset: {
                                width: 0,
                                height: 2,
                            },
                            shadowOpacity: 0.25,
                            shadowRadius: 3.84,

                            elevation: 5,
                        }}>
                            <div className={"icon-search-container" + (this.state.isSearchActive ? " active" : "")}
                                 onClick={this.onSearchClick.bind(this)}>
                                <i className="fas fa-search"></i>
                                <input type="text" className="search-input" data-ic-class="search-input"
                                       onBlur={this.onSearchBlur.bind(this)}
                                       onKeyPress={(event) => {
                                           if (event.key === 'Enter') {
                                               this.onSearchEnter(event.target.value);
                                           }
                                       }}
                                       ref={(input) => {
                                           this.searchInput = input;
                                       }}
                                       placeholder="Suchen nach(Sportart, Trainer, Sportstätte,...)"/>
                            </div>
                        </div>
                    </div>

                </div>
                {
                    mobileDisplay &&
                    <div className={"drawerbackground " + this.state.drawerSlideState} onClick={() => {
                        this.state.drawerOpened = false;
                        this.state.drawerSlideState = 'slideOut';
                        this.state.drawerSlideStateBg = 'slideOutBg';
                        let that = this;
                        setTimeout(function () {
                            that.state.drawerSlideState = 'hidden';
                            that.state.drawerSlideStateBg = '';
                            that.setState(that.state);
                        }, 500);
                        this.setState(this.state);
                    }}>
                        <div className={"drawer " + this.state.drawerSlideState} onClick={() => {

                        }}>

                            {
                                <ul className="firstMenu">
                                    {
                                        this.state.linkArray.map((ob) =>
                                            <li className={"first-li" + (ob.children ? " with-children" : "")}
                                                key={ob.title}>
                                                {
                                                    ob.link &&
                                                    <a href={ob.link}>{ob.title}</a>
                                                }
                                                {
                                                    (ob.path) &&
                                                    <Link to={ob.path}>{ob.title}</Link>
                                                }
                                                {
                                                    (!ob.path) && (!ob.link) &&
                                                    <a>{ob.title}</a>
                                                }
                                                {
                                                    ob.children &&
                                                    <ul className="ul-2">
                                                        {
                                                            ob.children.map((ob) =>
                                                                <li className={"second-li" + (ob.children ? " with-children" : "")}
                                                                    key={ob.title}>
                                                                    {
                                                                        ob.link &&
                                                                        <a className="text"
                                                                           href={ob.link}>{ob.title}</a>
                                                                    }
                                                                    {
                                                                        (ob.path) &&
                                                                        <Link className="text"
                                                                              to={ob.path}>{ob.title}</Link>
                                                                    }
                                                                    {
                                                                        ob.children &&
                                                                        <ul className="ul-3">
                                                                            {
                                                                                ob.children.map((ob) =>
                                                                                    <li className={"third-li" + (ob.children ? " with-children" : "")}
                                                                                        key={ob.title}>
                                                                                        {
                                                                                            ob.link &&
                                                                                            <a className="text"
                                                                                               href={ob.link}>{ob.title}</a>
                                                                                        }
                                                                                        {
                                                                                            (ob.path) &&
                                                                                            <Link className="text"
                                                                                                  to={ob.path}>{ob.title}</Link>
                                                                                        }

                                                                                    </li>
                                                                                )
                                                                            }
                                                                        </ul>
                                                                    }
                                                                </li>
                                                            )
                                                        }
                                                    </ul>
                                                }
                                            </li>
                                        )
                                    }
                                </ul>
                            }
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default withRouter(Main);
